<template>
  <div>
    <header-navigation></header-navigation>
    <div v-if="bannerContent">
      <banner :acf="bannerContent" :data="bannerContent"></banner>
    </div>
    <pageloader v-if="pageload" />
    <div style="border:1px solid lightgrey; border-top:20px solid #0D0A15;margin:70px;">
      
    <div class="blog-post-container" v-if="filteredContent.length">
      <div class="blog-post boxShadow" v-for="(content1, index) in content" :key="index" v-if="filteredContent[index]" >

         <div class="boxShadowContainer">
            <div v-if="filteredContent[index]"  class="document_title">
              <strong>{{ filteredContent[index][0].document_title}}</strong>
            </div>
      
            <div class="download-section">
            
              <a :href="filteredContent[index][0].document_cta" target="_blank"  style="cursor:pointer">
                  <span v-if="filteredContent[index]" class="btn d-flex document-btn-cta" style="justify-content: center; align-items: center; gap:8px" @click=filteredContent[index][0].document_cta>
                    
                    Download
                    <img
                  src="@/assets/images/download_icon_black.png"
                  alt=""
                  class="download-icon"
                />
                  </span>
                </a>
            </div>
            </div>
        
    

       <p v-if="! filteredContent[index]" style="font-size:18px;text-align:center; padding:15px; margin: 0px 30px;min-height: 100px; display: flex; align-items: center; justify-content: center; color: #2c2a2a">Search country to view documents</p>
       
      </div>
    </div>




    <p v-if="!filteredContent.length" style="font-size:18px;text-align:center; padding:15px; margin: 0px 30px;min-height: 100px; display: flex; align-items: center; justify-content: center; color: #2c2a2a">Search country to view documents</p>
  </div>

  <div v-if="$route.params.region">
    <footer>
      <nav class="company-pages px-3 px-md-0">
        <div class="container">
          <div class="">
            <footer-navigation
              v-bind:category="'quick-links'"
            ></footer-navigation>
          </div>
          <hr class="d-none d-md-block" />

          <div class="row">
            <div class="col-lg-8 my-5 mt-md-0 my-lg-0">
              <footer-navigation
                v-bind:category="'useful-links'"
              ></footer-navigation>
            </div>

            <div class="col-lg-4">
              <social-media></social-media>
              <div class="copyright-disclaimers d-none d-md-block">
                <p><span>© ResMed</span> {{ $getTranslation("All rights reserved.", $route.params.region) }}</p>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </footer>
  </div>
  </div>
</template>

<script>
import headerNavigation from "./components/navigation/header.vue";
import footerNavigation from "./components/navigation/footer.vue";
import articleHeader from "./components/navigation/articles-blog-header.vue";
import Pageloader from "./components/shared-support/pageloader.vue";
import banner from "./components/consumers/FSN_Banner.vue";
import wpApi from "./services/wpApi";

export default {
  components: { headerNavigation, footerNavigation, articleHeader, Pageloader, banner},
  data() {
    return {
      content: {},
      pageload: true,
      bannerContent: null,
      countries: [],
      filteredContent:{},
      currentCountry: null
    };
  },
  name: "Blog",
  created() {},
  async mounted() {
    window.filterDocuments=this;
    try {
      const data = await wpApi.getPageBySlug("AstalFSN");
      this.pageload = false;
      this.content = this.getAllInformation(data, "fsn_documents");
      this.pageNotFound(data.data.length);
      this.bannerContent = this.getComponentData(data, "support_banner_astral");
      this.bannerContent.countries = this.countries
    } catch (e) {
      this.pageNotFound();
    }
  },
  methods: {
    getComponentData(data, componentName) {
      if (!data.data.fields) {
        return null;
      }
      const component = _.find(data.data.fields, [
        "acf_fc_layout",
        componentName,
      ]);
      if (component) {
        return component[componentName];
      } else {
        return null;
      }
    },
    getAllInformation(data, componentName)
    {
      if (!data.data.fields) {
        return null;
      }
      const fileDetails = _.filter(data.data.fields, [
        "acf_fc_layout",
        componentName.replace('_','-'),
      ]);
      var records = [];
        fileDetails.forEach(element => {
         records.push( element[componentName]);
      });
      
      records.forEach(element => {
        element.files.forEach(file => {
          try{
          if(!this.countries.includes(file.country)) this.countries.push(file.country)
          }
          catch(e){console.log(e)}
        });
      });

      return records;
    },
    filterDocuments()
    {
      
      var country = document.getElementById('searchInput').value
     this.currentCountry = country
      var localContent = Array.from(this.content)
      this.filteredContent = []
      
      if(country && country !== ""){
        this.content.forEach((element,index)  => {
          var newfiles = element.files.filter(file => file.country === country);
          if(newfiles.length > 0) 
          this.filteredContent.push(newfiles);
        });

      }
      else {this.filteredContent = [];}
      
    },
    pageNotFound(data) {
      if (data == 0) {
        this.$router.push({
          name: "404",
          params: {
            region: this.$route.params.region,
            slug: "-page-sleep-apnea",
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.blog-post-container {
  display: grid;
  grid-template-columns: auto auto auto;
  grid-gap: 20px;
  justify-content: center;
  margin: 40px auto;

  @media (max-width: 767px) {
    grid-template-columns: auto;
  }
}

.blog-post {
  padding: 1.75rem;
  border: 1px solid #f4f4f4;
  background: #ffffff;
  box-shadow: -1px 0.25rem 12px 2px rgb(0 0 0 / 13%);
  min-height:120px;
  min-width:200px;
  max-width:200px;

  h3 {
    font-size: clamp(14px, 18px, 20px);
    font-family: "Plus Jakarta Sans", sans-serif;
    font-weight: 500;
    color: #2c2a2a;
  }

  p {
    font-family: "Plus Jakarta Sans", sans-serif;
    font-weight: 500;
    font-size: clamp(12px, 16px, 18px);
    color: #2c2a2a;
  }
}
.search-btn {
    border-radius: 50rem !important;
    background-color:#0D0A15
  }
  .search-btn {
    @media (max-width: 767px) {
      border-top-right-radius: 5px !important;
      border-bottom-right-radius: 5px !important;
      border-top-left-radius: 5px !important;
      border-bottom-left-radius: 5px !important;
    }
  }
  .search-btn {
  @media (max-width: 768px) {
    width: 100%;
  }
}
input[name="Country"] {
    height: 38px;
    padding: 0rem 1.3125rem;
    font-size: 0.875rem;
    font-weight: 500;
    letter-spacing: -0.21px;
    // border-top-right-radius: 0.25rem;
    // border-bottom-right-radius: 0.25rem;
    border-radius: 4px !important;

    @media (max-width: 567px) {
      // border-top-right-radius: 0;
      // border-bottom-right-radius: 0;
    }

    &::placeholder {
     
      font-size: 14px;
      font-family: "Plus Jakarta Sans", sans-serif;
      font-weight: 500;
    }

    &:focus {
      box-shadow: none;
      outline: 0;
      border-color: #ced4da;
    }
  }


.blog-post-container {
  display: grid;
  grid-template-columns: auto auto auto;
  grid-gap: 20px;
  justify-content: center;
  margin: 20px auto;

  @media (max-width: 767px) {
    grid-template-columns: auto;
  }
}

.blog-post {
  padding: 1.75rem;
  border: 1px solid #f4f4f4;
  background: #ffffff;
  box-shadow: -1px 0.25rem 12px 2px rgb(0 0 0 / 13%);
    min-height: 180px;
  min-width: 300px;
  max-width: 300px;

  h3 {
    font-size: clamp(14px, 18px, 20px);
    font-family: "Plus Jakarta Sans", sans-serif;
    font-weight: 500;
    color: #2c2a2a;
  }

  p {
    font-family: "Plus Jakarta Sans", sans-serif;
    font-weight: 500;
    font-size: clamp(12px, 16px, 18px);
    color: #2c2a2a;
  }
}

.blog-post-container {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.boxShadow {
  position: relative;
  background-color: #fff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  padding: 14px;
  border-radius: 4px;
  border-top: 4px solid #0d0a15;
  width: 100%;
}

.boxShadowContainer {
  display: flex;
  flex-direction: column;
  min-height: 128px;
  justify-content: space-between;
}

.document_title {
  min-height: 42px;
  text-align: left;
  display: flex;
  align-items: center;
}

.document_title strong {
  line-height: 1.6;
  color: #020202;
  font-size: 16px;
}

.download-section {
  display: flex;
  justify-content:center;
  margin-top: auto;
}

.download-icon {
  height: 20px;
  cursor: pointer;
}
</style>
